import amplitude from "amplitude-js"
import type { AmplitudeClient } from "amplitude-js"
import { getMetaAttributionParams } from "./meta"
import { Experiment } from "@amplitude/experiment-js-client"
import type { ExperimentClient } from "@amplitude/experiment-js-client"
import { getSnapchatClickId } from "./snapchat"

class Amplitude {
  constructor() {
    this.instance = amplitude.getInstance()

    this.instance.init(
      process.env.REACT_APP_AMPLITUDE_API_KEY || "",
      undefined,
      {
        includeUtm: true,
        includeReferrer: true,
        includeGclid: true,
        saveParamsReferrerOncePerSession: false,
        apiEndpoint: "amplitude.thepure.app",
      },
    )

    const deploymentKey = process.env.REACT_APP_EXPERIMENT_DEPLOYMENT_KEY || ""
    this.experiment = Experiment.initializeWithAmplitudeAnalytics(deploymentKey)
  }

  instance: AmplitudeClient | null = null
  experiment: ExperimentClient | null = null

  async fetchExperimentOptions(flagKeys: string[]) {
    await this.experiment?.fetch(undefined, { flagKeys })
  }

  async fetchExperimentVariant(variant: string) {
    return await this.experiment?.variant(variant)
  }

  async fetchAllExperiments() {
    return await this.experiment?.all()
  }
}

export const amplitudeClient = new Amplitude()

export const sendAmplitudeEvent = (
  eventType: string,
  eventProperties?: Record<
    string,
    string | number | undefined | string[] | number[] | null
  >,
  callback?: (responseCode: number, responseBody: Object) => void,
) => {
  amplitude.getInstance().logEvent(
    eventType,
    {
      ...eventProperties,
      onboarding_host: window.location.hostname,
      utm_medium: new URLSearchParams(window.location.search).get("utm_medium"),
      ...getMetaAttributionParams(),
      sc_click_id: getSnapchatClickId(),
    },
    callback,
  )
}

export const sendEventsEvenWhenPageCloses = () => {
  amplitude.getInstance().setTransport("beacon")
}

export const sendEventsNormally = () => {
  amplitude.getInstance().setTransport("http")
}

export const setAmplitudeUserId = (id: string | null) => {
  amplitude.getInstance().setUserId(id)
}

export const setAmplitudeUserProperties = (
  properties: Record<string, string>,
) => {
  amplitude.getInstance().setUserProperties(properties)
}
